<div class="circles">
  <li></li>
  <li></li>
  <li></li>
  <li></li>
</div>
<section class="home-main-section">
  <h1 class="SEO">Rahil Hastu</h1>
  <h2 class="SEO">
    I'm a Software Developer. I'm currently pursuing my masters from Arizona
    State University (ASU) and I have 3 years of work eperience
  </h2>
  <h4 class="SEO">
    I'm accepted into Google Summer of Code'23 by the Plone foundation and will
    be working on creating the User Group settings for Plone
  </h4>
  <div class="intro-section">
    <span class="uphtml">&lt;html&gt;</span>
    <span class="upintro">&lt;intro&gt;</span>
    <div class="title">
      <div class="hi">
        <span>H</span>
        <span>i</span>
        <span>,</span>
      </div>
      <div class="myName">
        <span>I</span>
        <span>'</span>
        <span>m&nbsp;</span>
        <span class="Rtitle">R</span>
        <span>a</span>
        <span>h</span>
        <span>i</span>
        <span>l</span>
        <span>,</span>
      </div>
      <div class="sftDevp">
        <span>S</span>
        <span>o</span>
        <span>f</span>
        <span>t</span>
        <span>w</span>
        <span>a</span>
        <span>r</span>
        <span>e</span>
        <span>&nbsp;D</span>
        <span>e</span>
        <span>v</span>
        <span>e</span>
        <span>l</span>
        <span>o</span>
        <span>p</span>
        <span>e</span>
        <span>r</span>
        <span>.</span>
      </div>
      <div class="subtitle">Python | CSS | HTML | React | Angular | C++</div>
    </div>
    <h5 class="SEO">Rahil Hastu's Skills</h5>
    <span class="downintro">&lt;/intro&gt;</span>
    <span class="downbody">&lt;body&gt;</span>
  </div>
  <div class="bigR">
    <div class="imageWrapper">
      <div class="rlogo">
        <div class="imgR"></div>
        <svg
          class="svgR"
          viewBox="0 0 454 544"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="frontR"
            d="M103.505 111.912C103.831 108.688 104.625 104.761 105.887 100.13C107.29 94.9846 108.833 89.3245 110.516 83.1497C114.303 69.2566 116.637 56.6354 117.52 45.2862C118.402 33.937 119.474 25.9469 120.737 21.3159C123.121 12.5683 133.244 8.89239 151.105 10.2881C169.997 11.9554 200.847 18.4268 243.653 29.7023L264.541 35.2042C349.638 57.6193 395.489 97.2719 402.093 154.162C403.365 161.666 403.394 169.671 402.181 178.176C401.484 186.816 399.804 196.025 397.139 205.801C391.669 225.869 382.892 242.86 370.808 256.774C358.864 270.173 342.912 283.068 322.952 295.458C302.195 308.742 290.484 320.272 287.819 330.049C286.276 335.709 286.588 345.718 288.755 360.077C291.062 373.92 294.19 388.808 298.14 404.739C302.089 420.67 306.249 435.829 310.619 450.216C315.504 464.739 319.637 474.927 323.016 480.781C335.878 504.574 341.397 519.816 339.574 526.505L337.891 532.68C335.086 542.971 325.431 545.943 308.927 541.596L301.191 539.558C285.719 535.483 273.547 525.383 264.676 509.258C259.419 500.153 250.398 472.407 237.614 426.022C231.222 402.83 225.701 384.555 221.05 371.197C217.056 357.46 212.993 347.014 208.863 339.86C205.388 332.326 201.025 327.041 195.773 324.003C191.036 321.101 184.542 318.563 176.29 316.389C159.786 312.042 146.359 315.675 136.007 327.287C126.312 338.521 119.08 352.886 114.311 370.381C109.683 387.361 106.882 403.72 105.909 419.457C105.077 434.68 104.31 443.578 103.608 446.151C99.9619 459.53 91.8817 467.88 79.3681 471.202C67.5105 474.145 54.1034 473.647 39.1469 469.707C23.6746 465.632 12.6541 459.42 6.08525 451.071C-0.483564 442.723 -1.73427 431.088 2.33311 416.165C4.01617 409.991 8.90907 402.18 17.0118 392.732C25.1146 383.285 31.4123 373.362 35.9049 362.964C37.8231 357.954 40.3251 349.789 43.4107 338.469C47.012 327.284 51.2672 312.687 56.1761 294.678L81.8427 200.513L83.804 190.275L89.0636 170.979L103.505 111.912ZM173.013 258.445L181.523 260.687C216.593 269.925 246.617 269.285 271.595 258.767C296.713 247.735 312.988 228.583 320.422 201.312L324.84 185.103C331.432 160.919 328.627 139.774 316.426 121.67C304.881 103.187 285.183 90.277 257.333 82.9411L245.729 79.8845L231.383 77.7603C221.584 75.1791 212.396 74.4134 203.818 75.463C195.756 76.6485 190.112 83.1587 186.887 94.9936L179.659 115.426L172.927 140.125L169.629 149.183L151.746 214.79C147.679 229.712 146.819 239.964 149.167 245.546C151.655 250.613 159.604 254.913 173.013 258.445Z"
            fill="#FC766A"
          />
          <path
            class="backR"
            d="M153.505 101.912C153.831 98.6884 154.625 94.7613 155.887 90.1303C157.29 84.9846 158.833 79.3245 160.516 73.1497C164.303 59.2566 166.637 46.6354 167.52 35.2862C168.402 23.937 169.474 15.9469 170.737 11.3159C173.121 2.56833 183.244 -1.10761 201.105 0.288058C219.997 1.95539 250.847 8.4268 293.653 19.7023L314.541 25.2042C399.638 47.6193 445.489 87.2719 452.093 144.162C453.365 151.666 453.394 159.671 452.181 168.176C451.484 176.816 449.804 186.025 447.139 195.801C441.669 215.869 432.892 232.86 420.808 246.774C408.864 260.173 392.912 273.068 372.952 285.458C352.195 298.742 340.484 310.272 337.819 320.049C336.276 325.709 336.588 335.718 338.755 350.077C341.062 363.92 344.19 378.808 348.14 394.739C352.089 410.67 356.249 425.829 360.619 440.216C365.504 454.739 369.637 464.927 373.016 470.781C385.878 494.574 391.397 509.816 389.574 516.505L387.891 522.68C385.086 532.971 375.431 535.943 358.927 531.596L351.191 529.558C335.719 525.483 323.547 515.383 314.676 499.258C309.419 490.153 300.398 462.407 287.614 416.022C281.222 392.83 275.701 374.555 271.05 361.197C267.056 347.46 262.993 337.014 258.863 329.86C255.388 322.326 251.025 317.041 245.773 314.003C241.036 311.101 234.542 308.563 226.29 306.389C209.786 302.042 196.359 305.675 186.007 317.287C176.312 328.521 169.08 342.886 164.311 360.381C159.683 377.361 156.882 393.72 155.909 409.457C155.077 424.68 154.31 433.578 153.608 436.151C149.962 449.53 141.882 457.88 129.368 461.202C117.51 464.145 104.103 463.647 89.1469 459.707C73.6746 455.632 62.6541 449.42 56.0852 441.071C49.5164 432.723 48.2657 421.088 52.3331 406.165C54.0162 399.991 58.9091 392.18 67.0118 382.732C75.1146 373.285 81.4123 363.362 85.9049 352.964C87.8232 347.954 90.3251 339.789 93.4107 328.469C97.012 317.284 101.267 302.687 106.176 284.678L131.843 190.513L133.804 180.275L139.064 160.979L153.505 101.912ZM223.013 248.445L231.523 250.687C266.593 259.925 296.617 259.285 321.595 248.767C346.713 237.735 362.988 218.583 370.422 191.312L374.84 175.103C381.432 150.919 378.627 129.774 366.426 111.67C354.881 93.1865 335.183 80.277 307.333 72.9411L295.729 69.8845L281.383 67.7603C271.584 65.1791 262.396 64.4134 253.818 65.463C245.756 66.6485 240.112 73.1587 236.887 84.9936L229.659 105.426L222.927 130.125L219.629 139.183L201.746 204.79C197.679 219.712 196.819 229.964 199.167 235.546C201.655 240.613 209.604 244.913 223.013 248.445Z"
            fill="#FC766A"
          />
        </svg>
      </div>
    </div>
  </div>
</section>
